import {blurForm} from '../behaviors/inline-comment'
import {hasDirtyFields} from '../has-interactions'
// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'
import {remoteForm} from '@github/remote-form'

// Show the form to edit the team's description.
on('click', '.js-team-discussions-team-description-toggle', function () {
  /* eslint-disable-next-line github/no-d-none */
  document.querySelector<HTMLElement>('.js-team-discussions-team-description')!.classList.toggle('d-none')
  /* eslint-disable-next-line github/no-d-none */
  document.querySelector<HTMLElement>('.js-team-discussions-team-description-form')!.classList.toggle('d-none')
})

// Show the form to write a new discussion post.
on('click', '.js-team-discussions-post-toggle', function (event) {
  const postForm = (event.target as Element).closest<HTMLElement>('.js-teams-write-a-post')!
  if (postForm.classList.contains('active')) return

  postForm.classList.add('active')
  /* eslint-disable-next-line github/no-d-none */
  postForm.querySelector<HTMLElement>('.js-team-discussions-post-compose')!.classList.remove('d-none')
  /* eslint-disable-next-line github/no-d-none */
  postForm.querySelector<HTMLElement>('.js-post-placeholder')!.classList.add('d-none')
  postForm.querySelector<HTMLElement>('.js-title-field')!.focus()
})

function hideReplyForm(target: Element) {
  blurForm(target as HTMLFormElement)
}

function hidePostForm(postForm: Element) {
  const writePost = postForm.querySelector<HTMLElement>('.js-team-discussions-post-compose')!
  /* eslint-disable-next-line github/no-d-none */
  if (!writePost.classList.contains('d-none')) {
    /* eslint-disable-next-line github/no-d-none */
    writePost.classList.add('d-none')
    /* eslint-disable-next-line github/no-d-none */
    postForm.querySelector<HTMLElement>('.js-post-placeholder')!.classList.remove('d-none')
    postForm.classList.remove('active')
  }

  /* eslint-disable-next-line github/no-d-none */
  postForm.querySelector<HTMLElement>('.js-comment-form-error')!.classList.add('d-none')
}

// Hides any of the comment forms, which could be the new post form
// or an actual "comment" form
function hideForm(target: Element) {
  const postForm = target.closest('.js-teams-write-a-post')
  if (postForm) {
    return hidePostForm(postForm)
  }

  const isReplyForm = target.closest('.js-teams-reply-to-post')
  if (isReplyForm) {
    return hideReplyForm(target)
  }
}

function clearInlineErrors(target: Element) {
  const replyForm = target.closest('.js-teams-reply-to-post')
  const errorContainer = replyForm && replyForm.querySelector('.js-comment-form-error')
  /* eslint-disable-next-line github/no-d-none */
  errorContainer && errorContainer.classList.add('d-none')
}

// Hide the new post form and restore default privacy value if the 'Cancel' button was clicked.
on('click', '.js-hide-post-form', function (event) {
  const form = (event.target as Element).closest<HTMLFormElement>('.js-new-comment-form')!

  if (!hasDirtyFields(form) || confirm((event.target as Element).getAttribute('data-confirm-cancel-text')!)) {
    hideForm(event.target as Element)
  } else {
    // Do not reset form
    event.preventDefault()
  }
})

// Clear error container on the inline reply form if the 'Cancel' button was clicked.
on('click', '.js-hide-inline-comment-form', function (event) {
  clearInlineErrors(event.target as Element)
})

// On successful post or reply creation, hide the form and any errors.
// Also make sure that the new post form still defaults to creating public posts.
remoteForm('.js-new-comment-form', async function (form, wants) {
  await wants.text()
  hideForm(form)
  clearInlineErrors(form)
})

// Hide the edit form for the team description and display the actual description again.
remoteForm('.js-team-discussions-team-description-form', async function (form, wants) {
  try {
    await wants.text()
  } catch (e) {
    // Do nothing
  }

  const description = document.querySelector<HTMLElement>('.js-team-discussions-team-description')!
  const field = document.querySelector<HTMLTextAreaElement>('.js-team-discussions-team-description-field')!

  /* eslint-disable-next-line github/no-d-none */
  description.classList.toggle('d-none')
  /* eslint-disable-next-line github/no-d-none */
  form.classList.toggle('d-none')

  if (field.value.trim()) {
    description.textContent = field.value
    field.defaultValue = field.value
  } else {
    // eslint-disable-next-line i18n-text/no-en
    description.textContent = 'This team has no description'
    field.defaultValue = ''
  }
})

function updatePinnedPostCounter(counter: Element, change: number) {
  counter.textContent = (parseInt(counter.textContent!) + change).toString()
}

// Update pin button tooltip and pinned post counter.
// Also fade out and remove post from the pinned tab if necessary.
remoteForm('.js-comment-pin', async function (form, wants) {
  const submit = form.querySelector<HTMLElement>('button[type=submit]')!
  // eslint-disable-next-line github/no-blur
  submit.blur()

  await wants.text()

  const input = form.querySelector<HTMLInputElement>('.js-pinned-discussion-input')!
  const counter = document.querySelector('#pinned_posts_counter')
  const label = submit.getAttribute('aria-label')!
  const altLabel = submit.getAttribute('data-alternate-aria-label')!

  submit.setAttribute('data-alternate-aria-label', label)
  submit.setAttribute('aria-label', altLabel)
  submit.classList.toggle('pinned')

  const wasPinned = submit.classList.contains('pinned')

  // On the team discussion show page there is no counter for pinned discussions, so only bother
  // with this logic on the index page (where there is a counter).
  if (counter) {
    updatePinnedPostCounter(counter, wasPinned ? 1 : -1)

    const pinnedTab = counter.closest<HTMLElement>('.js-pinned-post-tab')!
    if (!wasPinned && pinnedTab.classList.contains('selected')) {
      const container = form.closest<HTMLElement>('.js-comment-delete-container')!
      fadeOut(container)
    }
  }

  input.value = wasPinned ? '0' : '1'
})

function fadeOut(element: HTMLElement) {
  element.addEventListener(
    'transitionend',
    function (event: TransitionEvent) {
      if (event.propertyName === 'opacity') {
        element.remove()
      }
    },
    {once: true},
  )
  element.classList.add('fade-out')
}

// Update pinned post counter after a pinned post is deleted.
remoteForm('.js-comment-delete', async function (form, wants) {
  await wants.text()
  const post = form.closest('.discussion-post')
  const pinSubmit = post && post.querySelector('.js-comment-pin button[type=submit]')
  if (pinSubmit && pinSubmit.classList.contains('pinned')) {
    const counter = document.querySelector('#pinned_posts_counter')
    counter && updatePinnedPostCounter(counter, -1)
  }
})

// With text selected from a discussion post or reply, hitting "r" focuses the
// new reply form with the quoted text.
on('quote-selection', '.js-discussion-post', function (event) {
  const container = (event.target as Element).querySelector<HTMLElement>('.js-inline-comment-form-container')!
  container.classList.add('open')
  container.querySelector<HTMLElement>('.js-write-tab')!.click()
  container.querySelector<HTMLElement>('.js-comment-field')!.focus()
})

// Hide subscribe form and show unsubscribe form once subscribed
remoteForm('.js-comment-subscribe', async function (form, wants) {
  await wants.text()
  toggleSubscriptionForm(form, '.js-comment-unsubscribe')
})

// Hide unsubscribe form and show subscribe form once unsubscribed
remoteForm('.js-comment-unsubscribe', async function (form, wants) {
  await wants.text()
  toggleSubscriptionForm(form, '.js-comment-subscribe')
})

function toggleSubscriptionForm(form: HTMLFormElement, hiddenFormSelector: string) {
  /* eslint-disable-next-line github/no-d-none */
  form.classList.add('d-none')
  /* eslint-disable-next-line github/no-d-none */
  form.parentElement!.querySelector<HTMLElement>(hiddenFormSelector)!.classList.remove('d-none')
}

remoteForm('.js-discussion-post-update', async function (form, wants) {
  const comment = form.closest('.js-comment')
  if (!comment) return

  const title = comment.querySelector('.js-comment-title')
  if (!title) return

  const response = await wants.json()
  title.textContent = response.json.title
})
